import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Dropdown } from 'antd'
import store from 'store'

import classNames from 'classnames'
import SettingsService from 'popups/Settings/api/Settings'
import { autoLockOptions } from 'popups/Settings'
import koreanIcon from '@/assets/images/country/icon-korean-16.svg'
import japanIcon from '@/assets/images/country/icon-japan-16.svg'
import usaIcon from '@/assets/images/country/icon-american-16.svg'
import countryArrowDownIcon from '@/assets/images/cheveron-down-24.svg'
import styles from './style.module.scss'

const langMap = {
  ko: { name: '한국어', code: 'ko-KR', icon: koreanIcon },
  ja: { name: '日本語', code: 'ja-JP', icon: japanIcon },
  en: { name: 'English', code: 'en-US', icon: usaIcon },
}

const LanguageSwitcher = ({ country = false }) => {
  const dispatch = useDispatch()
  const locale = useSelector((state) => state.settings.locale)
  const settings = useSelector((state) => state.settings)
  const { recoverKeyEnabled } = settings

  const changeLanguage = async (e) => {
    const { key } = e

    try {
      const languageCode = key.substr(0, 2)
      const token = store.get('app.user.token')
      const isIpBlockedPage = window.location.pathname.startsWith('/ip-blocked')

      if (token && !isIpBlockedPage) {
        const res = await SettingsService.put({
          local: languageCode,
        })

        if (res.code === 620) {
          const duration = store.get('app.settings.umkDuration')
          const autoLockKey = duration
            ? autoLockOptions((t) => t).find((option) => option.milliseconds === duration)?.key
            : '10'
          const res2 = await SettingsService.create({
            local: languageCode,
            autoLock: autoLockKey,
            recoveryKeyToEmail: recoverKeyEnabled === 'email',
          })
          console.log('res2 - ', res2)
        }
      } else {
        dispatch({
          type: 'settings/SET_SETTINGS',
          payload: {
            locale: key,
          },
        })
      }

      e.domEvent.stopPropagation()
    } catch (error) {
      console.error(error)
    }
  }

  const onClick = (e) => {
    e.stopPropagation()
  }

  const langCode = locale.substr(0, 2)
  const language = langMap[langCode.toLowerCase()].name

  const menu = {
    selectedKeys: [locale],
    selectable: true,
    onClick: changeLanguage,
    items: [],
  }

  menu.items = Object.entries(langMap).map(([key, value]) => {
    return {
      key: value.code,
      label: (
        <React.Fragment>
          {country && <img src={value.icon} alt={value.name} />}
          {!country && (
            <span className="text-uppercase font-size-12 mr-2">{key.toUpperCase()}</span>
          )}
          {value.name}
        </React.Fragment>
      ),
    }
  })

  return (
    <Dropdown
      className={classNames(
        styles.languageSwitcher,
        'languageSwitcher',
        country && 'countryLanguageSwitcher',
      )}
      overlayClassName={classNames(country ? 'menuStyle2' : 'menuStyle1', 'contextMenu')}
      menu={menu}
      trigger={['click']}
      placement="bottomRight"
      onClick={onClick}
    >
      <div className={styles.dropdown}>
        <div className={styles.dropdownContent}>
          {country && <img src={langMap[langCode.toLowerCase()].icon} alt={language} />}
          <span className="text">{language}</span>
        </div>
        {country && <img src={countryArrowDownIcon} alt="arrowDownIcon" />}
      </div>
    </Dropdown>
  )
}

export default LanguageSwitcher
